import { c as _c } from "react/compiler-runtime";
import { Bell, BookOpen, ChevronRight, Globe, LogOut, ShieldCheck, Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const LOCALES: {
  id: "en" | "ru";
  label: string;
}[] = [{
  id: "en",
  label: "English"
}, {
  id: "ru",
  label: "Русский"
}];
export function SettingsPage(t0) {
  const $ = _c(30);
  const {
    onSignOut
  } = t0;
  const {
    i18n
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><h1 className="text-2xl font-semibold tracking-tight">Settings</h1><p className="text-sm text-muted-foreground">Account, security, and preferences.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Avatar className="size-12"><AvatarFallback>YO</AvatarFallback></Avatar>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-1"><div className="text-sm font-semibold">You</div><div className="text-xs text-muted-foreground">you@example.com · Joined Mar 2026</div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card><CardContent className="flex items-center gap-3 pt-6">{t2}{t3}<Badge variant="outline" className="gap-1 rounded-full font-normal text-emerald-700 dark:text-emerald-400"><ShieldCheck className="size-3" /> KYC verified</Badge></CardContent></Card>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Globe className="size-4" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== i18n) {
    t6 = LOCALES.map(l => <button key={l.id} type="button" onClick={() => void i18n.changeLanguage(l.id)} className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${i18n.resolvedLanguage === l.id ? "bg-foreground text-background" : "border hover:bg-muted"}`}>{l.label}</button>);
    $[5] = i18n;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Row icon={t5} label="Language" trailing={<div className="flex gap-1.5">{t6}</div>} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Wallet className="size-4" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Row icon={t9} label="Connected wallet" trailing={<span className="text-xs text-muted-foreground">Custodial · BSC</span>} />;
    t11 = <Separator />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t10 = $[11];
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Bell className="size-4" />;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Row icon={t12} label="Notifications" trailing={<ChevronRight className="size-4 text-muted-foreground" />} clickable={true} />;
    t14 = <Separator />;
    $[14] = t13;
    $[15] = t14;
  } else {
    t13 = $[14];
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ShieldCheck className="size-4" />;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Row icon={t15} label="Identity & KYC" trailing={<ChevronRight className="size-4 text-muted-foreground" />} clickable={true} />;
    t17 = <Separator />;
    $[17] = t16;
    $[18] = t17;
  } else {
    t16 = $[17];
    t17 = $[18];
  }
  let t18;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <BookOpen className="size-4" />;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Row icon={t18} label="Legal & disclosures" trailing={<ChevronRight className="size-4 text-muted-foreground" />} clickable={true} />;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== t7) {
    t20 = <Card><CardContent className="px-0 py-0">{t7}{t8}{t10}{t11}{t13}{t14}{t16}{t17}{t19}</CardContent></Card>;
    $[21] = t7;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <LogOut className="size-4" />;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] !== onSignOut) {
    t22 = <Button variant="outline" className="w-full gap-2 text-rose-600 hover:bg-rose-500/10 dark:text-rose-400" onClick={onSignOut}>{t21} Sign out</Button>;
    $[24] = onSignOut;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="pt-2 text-center text-[11px] text-muted-foreground">Residual provides infrastructure, not legal or financial advice. Consult your local regulator.</p>;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t20 || $[28] !== t22) {
    t24 = <div className="space-y-5">{t1}{t4}{t20}{t22}{t23}</div>;
    $[27] = t20;
    $[28] = t22;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  return t24;
}
function Row(t0) {
  const $ = _c(11);
  const {
    icon,
    label,
    trailing,
    clickable
  } = t0;
  const t1 = `flex items-center justify-between gap-3 px-5 py-3.5 ${clickable ? "cursor-pointer hover:bg-muted/50" : ""}`;
  let t2;
  if ($[0] !== icon) {
    t2 = <div className="grid size-8 place-items-center rounded-md bg-muted">{icon}</div>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="text-sm">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex items-center gap-3">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4 || $[9] !== trailing) {
    t5 = <div className={t1}>{t4}{trailing}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = trailing;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}